import { render, staticRenderFns } from "./reviewContract.vue?vue&type=template&id=4b71b965&scoped=true"
import script from "./reviewContract.vue?vue&type=script&lang=js"
export * from "./reviewContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71b965",
  null
  
)

export default component.exports